import styles from "./styles.module.css";

export default function RegistrosRondaQrcodeContagem({ registros, filtro }: iProps) {
    if (registros.length === 0) {
        return <div></div>;
    }

    let qrcodes: any[] = [];
    for (let reg of registros) {
        let qrcode = reg.descricao;
        if (qrcodes.filter((reg) => reg.qrcode === qrcode).length > 0) {
            continue;
        }
        qrcodes.push({
            id: reg.id_qrcode,
            qrcode: qrcode,
            quantidade: 0,
        });
    }
    for (let reg of registros) {
        let qrcode = reg.descricao;
        for (let idx in qrcodes) {
            if (qrcodes[idx].qrcode === qrcode) {
                qrcodes[idx].quantidade += 1;
                break;
            }
        }
    }

    return (
        <div>
            <p className={styles.contagemTitulo}>Rondas por TAG</p>
            <div className="div-row" style={{ alignItems: "start" }}>
                <div style={{ lineHeight: "25px", textAlign: "justify" }}>
                    {qrcodes
                        .sort((a, b) => a.id - b.id)
                        .map((qrcode, idx, arr) => {
                            if (idx % 2 === 1) {
                                return <div key={idx}></div>;
                            }
                            return (
                                <div key={idx} className={styles.qtdRegPorDia}>
                                    <span>
                                        {qrcode.qrcode} <b>{qrcode.quantidade}</b>
                                    </span>
                                </div>
                            );
                        })}
                </div>
                <div style={{ lineHeight: "25px", textAlign: "justify" }}>
                    {qrcodes
                        .sort((a, b) => a.id - b.id)
                        .map((qrcode, idx, arr) => {
                            if (idx % 2 === 0) {
                                return <div key={idx}></div>;
                            }
                            return (
                                <div key={idx} className={styles.qtdRegPorDia}>
                                    <span>
                                        {qrcode.qrcode} <b>{qrcode.quantidade}</b>
                                    </span>
                                </div>
                            );
                        })}
                </div>
            </div>
            <br></br>
        </div>
    );
}
interface iProps {
    registros: any[];
    filtro: any;
}
